import * as Sentry from '@sentry/browser';

import { SENTRY_ENABLED, isDevOrTest } from 'constants/environment';
import { WEBSITE_SENTRY_DSN } from 'constants/ids';
import { NODE_ENV, SENTRY_RELEASE } from 'constants/runtimeConfig';
import { LOOM_VERSION } from 'constants/versions';

export const levels = Sentry.Severity;

export const init = () => {
  if (!SENTRY_ENABLED) {
    return;
  }

  // Passing any falsey value as the DSN will disable sending events upstream
  Sentry.init({
    dsn: WEBSITE_SENTRY_DSN,
    release: SENTRY_RELEASE,
    environment: NODE_ENV,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Failed to fetch',
      'NetworkError when attempting to fetch resource.',
      'Fullscreen request denied',
      'Not in fullscreen mode',
      'GraphQL error: No Video found',
      'GraphQL error: Need logged in viewer to fetch info',
      "Cannot read property 'focus' of null",
      'Unexpected token < in JSON at position 0',
      /Users platform not supported/,
      /NotFoundError/,
      /AbortError/,
      'There is no clipping info for given tab',
    ],
    // ignore errors NOT coming from our CDN or website
    // https://github.com/getsentry/sentry-javascript/blob/master/packages/browser/examples/app.js
    whitelistUrls: [new RegExp(/loom\.com/)],
    beforeBreadcrumb(breadcrumb) {
      // noisy redux actions
      return [
        'update-video-player-mouse-active',
        'update-video-player-mouse-inactive',
        'update-video-player-current-time',
      ].includes(breadcrumb.message)
        ? null
        : breadcrumb;
    },
  });

  Sentry.configureScope(scope => {
    scope.setTag('loom_version', LOOM_VERSION);
  });

  return Sentry;
};

export const setUserContext = context => {
  if (!SENTRY_ENABLED) {
    return;
  }

  Sentry.configureScope(scope => {
    scope.setUser(context);
  });
};

const trackError = (
  exception,
  context = {},
  level = Sentry.Severity.Error,
  tags = {}
) => {
  if (!SENTRY_ENABLED) {
    return;
  }

  Sentry.withScope(scope => {
    scope.setTags(tags);
    scope.setLevel(level);
    scope.setExtras(context);
    Sentry.captureException(exception, context);
  });
};

export const logFatal = (exception, context = {}, tags = {}) => {
  return trackError(exception, context, Sentry.Severity.Fatal, tags);
};

export const logError = (exception, context = {}, tags = {}) => {
  return trackError(exception, context, Sentry.Severity.Error, tags);
};

export const addBreadcrumb = (...args) => Sentry.addBreadcrumb(...args);

// DEPRECATED, please use loggerx instead
export const logException = (exception, message = '', context = {}) => {
  if (!isDevOrTest) {
    return;
  }

  console.warn('[DEPRECATED]', message, exception, context);
};
